import { BrowserRouter, Routes, Route } from "react-router-dom";
import Acceuil from "./composants/Acceuil";
import LoginClient from "./composants/LoginClient";
import DemAdmin from "./composants/DemAdmin";
import RechClient from "./composants/RechClient";
import ClientDetail from "./composants/ClientDetail";
import ListeFamille from "./composants/ListeFamille";
import ListeFamilleMain from "./composants/ListeFamilleMain";
import ArticlesParFamille from "./composants/ArticlesParFamille";
import MainLayout from "./MainLayout";
import ChariotMain from "./composants/ChariotMain";
import CommandeInfo from "./composants/CommandeInfo";
import CommandeRecap from "./composants/CommandeRecap";
import RepresDetail from "./composants/RepresDetail";
import CommandeDetails from "./composants/CommandeDetails";
import DemCliFinal from "./composants/DemCliFinale";
import ToutArticles from "./composants/ToutArticles";
import DemRepres from "./composants/DemRepres";
import EtatPresenceClient from "./composants/EtatPresenceClient";
import CommandeParClientFinale from "./composants/CommandeParClientFinale";
import AjoutClient from "./composants/AjoutClient";
import ArticleListeStockNegative from "./composants/ArticleListeStockNegative";
import Messagedistant from "./composants/Messagedistant";
import MessageCree from "./composants/MessageCree";
import RechRepresentant from "./composants/RechRepresentant";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={LoginClient} />
        <Route path="/DemAdmin" Component={DemAdmin} />
        <Route path="/DemCliFinale" Component={DemCliFinal} />
        <Route path="/DemRepres" Component={DemRepres} />

        <Route path="/RechClient" Component={RechClient} />
        <Route path="/RechRepres" Component={RechRepresentant} />

        <Route path="/ClientDetail" Component={ClientDetail} />
        <Route path="/RepresDetail" Component={RepresDetail} />
        <Route path="/EtatPresenceClient" Component={EtatPresenceClient} />
        <Route path="/MessageDistant" Component={Messagedistant} />
        <Route path="/MessageCree" Component={MessageCree} />

        <Route
          path="/CommandeParClientFinale"
          Component={CommandeParClientFinale}
        />
        <Route
          path="/ArticleListeStockNegative"
          Component={ArticleListeStockNegative}
        />
        <Route path="/AjoutClient" Component={AjoutClient} />

        <Route path="/CommandeDetails/:id" Component={CommandeDetails} />

        <Route element={<MainLayout />}>
          <Route path="/ListeFamille" Component={ListeFamilleMain} />
          <Route path="/ArticlesParFamille" Component={ArticlesParFamille} />
          <Route path="/chariot" Component={ChariotMain} />
          <Route path="/chariot/commandeInfo" Component={CommandeInfo} />
          <Route
            path="/chariot/commandeInfo/commandeRecap"
            Component={CommandeRecap}
          />
          <Route path="/ToutArticles" Component={ToutArticles} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
